import { daysInMonth } from '@portal/utils/util-date';

type RangeDate = {
  dateFrom: string;
  dateTo: string;
};

export const getDateRange = (year: string, month?: string, day?: string): RangeDate => {
  if (day !== undefined && month !== undefined) {
    return {
      dateFrom: `${day}.${month}.${year}`,
      dateTo: `${day}.${month}.${year}`
    };
  }

  if (day === undefined && month !== undefined) {
    const lastDay = daysInMonth(new Date(Number(year), Number(month) - 1));
    return {
      dateFrom: `01.${month}.${year}`,
      dateTo: `${lastDay}.${month}.${year}`
    };
  }

  return {
    dateFrom: `01.01.${year}`,
    dateTo: `31.12.${year}`
  };
};
